var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-50px"
  }, [_c('div', {
    staticClass: "giftcard-slide-wrap"
  }, [_c('div', {
    staticClass: "giftcard-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.brands, function (brand) {
    var _vm$$route, _vm$$route$query;

    return _c('div', {
      key: brand === null || brand === void 0 ? void 0 : brand._id,
      class: "swiper-slide py-1 d-flex justify-center ".concat(((_vm$$route = _vm.$route) === null || _vm$$route === void 0 ? void 0 : (_vm$$route$query = _vm$$route.query) === null || _vm$$route$query === void 0 ? void 0 : _vm$$route$query._brand) === (brand === null || brand === void 0 ? void 0 : brand._id) ? 'is-active' : ''),
      on: {
        "click": function click($event) {
          return _vm.$emit('setBrand', brand);
        }
      }
    }, [_c('div', {
      staticClass: "rounded-item"
    }, [_c('img', {
      attrs: {
        "src": "https://daehanbooksgiftcard.com/".concat(brand === null || brand === void 0 ? void 0 : brand.subThumb),
        "alt": ""
      }
    })])]);
  }), 0)])]), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('div', {
    staticClass: ".giftcard-slide-wrap swiper-prev"
  }, [_c('img', {
    attrs: {
      "src": "/images/giftcard/arrow-lt.png",
      "alt": "<"
    }
  })]), _c('div', {
    staticClass: ".giftcard-slide-wrap swiper-next"
  }, [_c('img', {
    attrs: {
      "src": "/images/giftcard/arrow-rt.png",
      "alt": ">"
    }
  })])]);
}]

export { render, staticRenderFns }